//此文件由工具自动生成,不要手动修改此文件
//在/centralsvn/BaseCode/wpcommonEditors/User.xlsm中修改并生成
//update_time[2022.6.13 10:15:57]

let eventType = {};

eventType.getData = function() {
	var data = [
		{
			value : 1,
			name : "点击行为",
		},
		{
			value : 2,
			name : "进入页面",
		},
		{
			value : 3,
			name : "离开页面",
		},
		{
			value : 4,
			name : "点击活动",
		},
		{
			value : 5,
			name : "点击产品",
		},
		{
			value : 6,
			name : "点击底部菜单",
		},
		{
			value : 7,
			name : "用户分享",
		},
		{
			value : 8,
			name : "点击链接",
		},
		{
			value : 9,
			name : "搜索",
		},
		{
			value : 10,
			name : "点击banner",
		},
		{
			value : 11,
			name : "从外部页面跳转进入",
		},
		{
			value : 12,
			name : "点击关注",
		},
		{
			value : 13,
			name : "跳转外部页",
		},
		{
			value : 14,
			name : "跳转外部小程序",
		},
		{
			value : 15,
			name : "跳转视频号",
		},
		{
			value : 16,
			name : "文章阅读完成",
		},
		{
			value : 17,
			name : "页面访问时长",
		},
		{
			value : 18,
			name : "资源位点击",
		},
		{
			value : 19,
			name : "用户注册",
		},
		{
			value : 20,
			name : "完善信息",
		},
		{
			value : 21,
			name : "订阅消息",
		},
		{
			value : 22,
			name : "添加心愿",
		},
		{
			value : 23,
			name : "填写表单",
		},
		{
			value : 24,
			name : "点赞",
		},
	];
	return data;
};

export default eventType;



// WEBPACK FOOTER //
// ./src/utils/EventType.js